<template>
  <div class="comp-correct-pop" id="correctPop">
    <tx-msg-box ref="correctMsg" @close="close" class="correct-msg-box"
                :options="{type: 'confirm', title: '试题纠错', width: '700px', showClose: true, align: 'tl', confirmButtonText: '提交', confirmButtonClass: 'btn-primary', callback: bindGradeQues, callbackClose: true}">
      <div class="pr20 pt10">
        <el-form ref="form" label-width="100px">
          <el-form-item class="mb5" label="题目编号：">
            {{currentOprQues.testID}}
          </el-form-item>
          <el-form-item class="mb5" label="错误类型：">
            <el-checkbox-group v-model="type">
              <el-checkbox v-for="item in correctType" :key="item.id" :label="item.id" name="type">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="错误描述：">
            <!--<quill-editor v-model="correctContent"
                          :options="editorOption"
                          @blur="onEditorBlur($event)"
                          @focus="onEditorFocus($event)"
                          @ready="onEditorReady($event)">
            </quill-editor>-->
            <el-input type="textarea" :rows="8" placeholder="我来说两句~~" v-model="correctContent"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </tx-msg-box>
  </div>
</template>

<script>
  /*!*
   * @author yueheqin
   * @date 2019/7/9
   * @project zujuanzaixian
   * @desc
   */
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  // import 'quill/dist/quill.core.css'
  // import 'quill/dist/quill.snow.css'
  // import 'quill/dist/quill.bubble.css'
  //
  // import { quillEditor } from 'vue-quill-editor'
  export default {
    name: 'comp-correct-pop',
    props: {},
    data () {
      return {
        correctContent: '',
        type: []
        // editorOption: {
        //   modules: {
        //     toolbar: [
        //       [{'size': ['small', false, 'large']}],
        //       ['bold', 'italic'],
        //       [{'list': 'ordered'}, {'list': 'bullet'}],
        //       ['link', 'image']
        //     ],
        //     history: {
        //       delay: 1000,
        //       maxStack: 50,
        //       userOnly: false
        //     },
        //     imageDrop: true,
        //     imageResize: {
        //       displayStyles: {
        //         backgroundColor: 'black',
        //         border: 'none',
        //         color: 'white'
        //       },
        //       modules: ['Resize', 'DisplaySize', 'Toolbar']
        //     }
        //   }
        // }
      }
    },
    computed: {
      ...mapState('pop', ['correctPopVisible', 'currentOprQues']),
      ...mapGetters('pop', ['correctType'])
    },
    components: {
      // quillEditor
    },
    watch: {
      'correctPopVisible': {
        handler (n, o) {
          if (n) {
            this.$nextTick(() => {
              this.open()
            })
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapMutations('pop', ['updateCorrectPopVisible']),
      ...mapActions('zujuan', ['correctTest']),
      bindGradeQues (type) {
        if (type === 'confirm') {
          if (this.score <= 0) {
            this.$message.error('请选择错误类型')
            return
          }
          if (!this.correctContent) {
            this.$message.error('请输入错误描述')
            return
          }
          this.correctTest({
            data: {
              testID: this.currentOprQues.testID,
              content: this.correctContent,
              type: this.type
            },
            config: {
              loading: '#correctPop'
            }
          }).then(res => {
            this.$notify.success({
              title: '提示',
              message: res.data
            })
            this.close()
            this.$refs.correctMsg.close()
          })
        }
      },
      open () {
        this.correctContent = ''
        this.type = []
        this.$refs.correctMsg.open()
      },
      close () {
        console.log('closeDialog')
        this.updateCorrectPopVisible(false)
      }
      // onEditorBlur (editor) {
      //   // console.log('editor blur!', editor)
      // },
      // onEditorFocus (editor) {
      //   // console.log('editor focus!', editor)
      // },
      // onEditorReady (editor) {
      //   // console.log('editor ready!', editor)
      // }
    }
  }
</script>

<style lang="less">
  .ql-snow .ql-picker-label::before{
    position: absolute;
  }
  .ql-editor{
    min-height: 150px;
    max-height: calc(100vh - 400px);
  }

  .correct-msg-box {
  }
</style>
